import fetch from "auth/FetchInterceptor"

const ProspectService = {}

ProspectService.create = function (data) {
  return fetch({
    url: "/prospect/create",
    method: "post",
    data: data,
  })
}

ProspectService.getAll = function (params = {}) {
  return fetch({
    url: "/prospect/all",
    method: "get",

    params: params,
  })
}

ProspectService.countNewProspects = function () {
  return fetch({
    url: "/prospect/count-new",
    method: "get",
  })
}

ProspectService.updateStatus = function (id, status) {
  return fetch({
    url: `/prospect/${id}/status`,
    method: "patch",
    data: {
      status,
    },
  })
}

ProspectService.delete = function (id, status) {
  return fetch({
    url: `/prospect/${id}`,
    method: "delete",
    data: {
      status,
    },
  })
}

export default ProspectService
